import { EventEmitter } from '@angular/core';
import { BULLET_POINT_TOOLBAR_FORMATS, QuillToolbarFormatType } from '../text-edit/constants';
import { CustomPDFReportOrientation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-orientation.enum';
import { CustomPDFReportModulePreviewImageService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report-module-preview-image.service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { TextEditComponent } from 'NewAngular/features/components/modals/text-edit/text-edit.component';
import * as i0 from "@angular/core";
import * as i1 from "CustomPDFReportsApp/ts/services/custom-pdf-report-module-preview-image.service";
import * as i2 from "@angular/common";
import * as i3 from "../confirm-modal/confirm-modal.component";
import * as i4 from "../modal-base/components/modal-base.component";
import * as i5 from "../modal-base/components/simple-modal-footer.component";
import * as i6 from "../modal-base/components/simple-modal-header.component";
import * as i7 from "NewAngular/features/components/modals/text-edit/text-edit.component";
const _c0 = ["textEditComponent"];
function TalkingPointTextEditModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "div", 12);
    i0.ɵɵelementEnd();
} }
function TalkingPointTextEditModalComponent_img_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.image, i0.ɵɵsanitizeUrl);
} }
function TalkingPointTextEditModalComponent_ycn_text_edit_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-text-edit", 14, 0);
    i0.ɵɵlistener("textChanged", function TalkingPointTextEditModalComponent_ycn_text_edit_7_Template_ycn_text_edit_textChanged_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.newText = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("extraFormats", ctx_r0.quillFormats)("text", ctx_r0.text);
} }
/**
 *
 * Talking Point Text Edit Modal Component
 *
 * Allows text edition with a WYSIWYG editor for talking points. Text is saved as HTML.
 *
 *
 * Input Properties:
 *
 *  title: A string for the modal header.
 *  text: HTML string that will be edited.
 *  defaultText: Default text to set text editor if reset
 *
 *
 * Output Properties:
 *
 *  textSaved: EventEmitter that emits when saving the edited text (as HTML string).
 *
 */
export class TalkingPointTextEditModalComponent {
    constructor(previewImageService, customPDFReportModulePreviewImageService) {
        this.previewImageService = previewImageService;
        this.customPDFReportModulePreviewImageService = customPDFReportModulePreviewImageService;
        this.textSaved = new EventEmitter();
        this.modalOpen = false;
        this.quillFormats = [QuillToolbarFormatType.SIZE, ...BULLET_POINT_TOOLBAR_FORMATS];
    }
    openModal() {
        this.text = this.talkingPoint.proposal_text;
        this.loading = true;
        this.warningLoading = false;
        this.modalOpen = true;
        this.customPDFReportModulePreviewImageService
            .getTalkingPointPreviewImage(this.securities.map((_) => _.securityId), this.talkingPoint, this.includeBenchmark)
            .subscribe((_) => {
            this.image = _.image;
            this.loading = false;
        }, () => {
            this.loading = false;
        });
    }
    closeModal() {
        this.modalOpen = false;
    }
    resetDefaultText() {
        if (this.textEditComponent && this.textEditComponent.quillEditor) {
            this.textEditComponent.quillEditor.root.innerHTML = this.defaultText;
        }
    }
    submitModal(confirm = true) {
        if (confirm) {
            this.modalOpen = false;
            if (this.newText !== this.text)
                this.textSaved.emit(this.newText);
        }
    }
    onSubmit() {
        this.warningLoading = true;
        this.previewImageService
            .getPDFReportModuleProposalsWarningMessage({
            talking_point_id: this.talkingPoint.id,
            proposal_text: this.newText,
        }, this.reportOrientation)
            .subscribe({
            next: (response) => {
                this.warningLoading = false;
                if (response.warning) {
                    this.warningModal.openModal();
                }
                else {
                    this.submitModal();
                }
            },
            error: () => {
                this.warningLoading = false;
            },
        });
    }
}
TalkingPointTextEditModalComponent.ɵfac = function TalkingPointTextEditModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointTextEditModalComponent)(i0.ɵɵdirectiveInject(i1.CustomPDFReportModulePreviewImageService), i0.ɵɵdirectiveInject(i1.CustomPDFReportModulePreviewImageService)); };
TalkingPointTextEditModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TalkingPointTextEditModalComponent, selectors: [["ycn-talking-point-text-edit-modal"]], viewQuery: function TalkingPointTextEditModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textEditComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.warningModal = _t.first);
    } }, inputs: { defaultText: "defaultText", title: "title", talkingPoint: "talkingPoint", securities: "securities", includeBenchmark: "includeBenchmark", reportOrientation: "reportOrientation" }, outputs: { textSaved: "textSaved" }, standalone: false, decls: 10, vars: 14, consts: [["textEditComponent", ""], [3, "closeModalHandler", "open", "requiresAction"], [3, "resetModalHandler", "closeModalHandler", "header", "resetModalText"], [1, "modal-body"], [1, "modal-section"], [1, "modal-message"], ["class", "loader", 4, "ngIf"], ["class", "mb-2", "style", "width: 100%", 3, "src", 4, "ngIf"], [3, "extraFormats", "text", "textChanged", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "submitButtonText", "loading"], [3, "confirmHandler", "confirmButtonText", "cancelButtonText", "confirmHeader", "confirmText"], [1, "loader"], [1, "loader-spinner"], [1, "mb-2", 2, "width", "100%", 3, "src"], [3, "textChanged", "extraFormats", "text"]], template: function TalkingPointTextEditModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function TalkingPointTextEditModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("resetModalHandler", function TalkingPointTextEditModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { return ctx.resetDefaultText(); })("closeModalHandler", function TalkingPointTextEditModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5);
        i0.ɵɵtemplate(5, TalkingPointTextEditModalComponent_div_5_Template, 2, 0, "div", 6)(6, TalkingPointTextEditModalComponent_img_6_Template, 1, 1, "img", 7)(7, TalkingPointTextEditModalComponent_ycn_text_edit_7_Template, 2, 2, "ycn-text-edit", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "ycn-simple-modal-footer", 9);
        i0.ɵɵlistener("cancelHandler", function TalkingPointTextEditModalComponent_Template_ycn_simple_modal_footer_cancelHandler_8_listener() { return ctx.closeModal(); })("submitHandler", function TalkingPointTextEditModalComponent_Template_ycn_simple_modal_footer_submitHandler_8_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "ycn-confirm-modal", 10);
        i0.ɵɵlistener("confirmHandler", function TalkingPointTextEditModalComponent_Template_ycn_confirm_modal_confirmHandler_9_listener($event) { return ctx.submitModal($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen)("requiresAction", true);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.title)("resetModalText", "Reset Default Text");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.image);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("cancelButtonText", "Cancel")("submitButtonText", "Update")("loading", ctx.warningLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonText", "Continue")("cancelButtonText", "Cancel")("confirmHeader", "Alert")("confirmText", "The text entered may be too long and flow into the module below. Continue or update with a shortened version.");
    } }, dependencies: [i2.NgIf, i3.ConfirmModalComponent, i4.ModalBaseComponent, i5.SimpleModalFooterComponent, i6.SimpleModalHeaderComponent, i7.TextEditComponent], encapsulation: 2 });
